import { Box, Typography, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useEffect, useState } from "react";
import { useDepositosStore } from "../../hooks/useDepositosStore";
import CustomTextField from "./CustomTextField";

const SelectorDeposito = () => {
  const { depositoSeleccionado, depositos, setDepositoSeleccionado } = useDepositosStore();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = deposito => {
    setDepositoSeleccionado(deposito);
    handleClose();
  };

  const handleChange = event => {
    const selectedId = event.target.value;
    const selectedDeposito = depositos.find(dep => dep.idDeposito === selectedId);
    setDepositoSeleccionado(selectedDeposito);
  };

  useEffect(() => {
    console.log("Depósito seleccionado:", depositoSeleccionado);
  }, [depositoSeleccionado]);

  return (
    <Box>
      <CustomTextField
        label={depositoSeleccionado?.descripcion ? "DEPÓSITO" : "Seleccione un depósito"}
        value={depositoSeleccionado?.idDeposito || ""}
        select
        variant="outlined"
        onChange={handleChange}
        sx={{
          mb: 0.5,
          "& .MuiFormLabel-root": {
            fontSize: "1rem",
            color: "#000",
          },
        }}
      >
        {depositos.map(deposito => (
          <MenuItem key={deposito.idDeposito} value={deposito.idDeposito}>
            {deposito.descripcion}
          </MenuItem>
        ))}
      </CustomTextField>
      {/* <Box
        onClick={handleOpen}
        sx={{
          backgroundColor: "#f1f1f1",
          borderRadius: "10px",
          px: 2,
          py: 1.2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#003366", mb: 0.5 }}>
          {depositoSeleccionado?.descripcion || "Seleccione un depósito"}
        </Typography>
        <ArrowDropDownIcon sx={{ color: "#444" }} />
      </Box>

      <Menu 
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {depositos.map((deposito) => (
          <MenuItem
            key={deposito.idDeposito}
            onClick={() => handleSelect(deposito)}
          >
            {deposito.descripcion}
          </MenuItem>
        ))}
      </Menu> */}
    </Box>
  );
};

export default SelectorDeposito;
